import { Link, Outlet } from "react-router-dom";

function App() {
  return (
    <div className="wrap">
      <header>
        {/* <Link to="/">
          <AiFillHome className="home_icon" />
        </Link> */}
        <Link to="/">
          <h1>이상형 월드컵</h1>
        </Link>
      </header>
      <main>
        <section>
          <div className="container">
            <Outlet />
          </div>
        </section>
      </main>
      <footer></footer>
    </div>
  );
}

export default App;
